<template lang="html">
	<entity-page id="page__luw" v-bind:loading="progress">
		<template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
        </template>

        <z-select
            name="type" id="type" label="Тип способа оплаты" v-bind:required="true" v-model="luw.type"
            v-validate="'required'" v-bind:error="errors.first('type')"  data-vv-name="type" v-bind:data-vv-as="' '"
        >
            <option value="" selectd disabled>Не установлен</option>
            <option v-for="type in Object.values(types)" v-bind:value="type.value">{{type.name}}</option>
        </z-select>

		<z-input-autocomplete
            v-show="parseInt(luw.type) === 1"
			v-model="luw.city_id" name="city_id" id="city_id" display-property="name" property="id" return="id" label="Город"
            v-bind:callback="getCities" v-bind:default="luw.city && luw.city.name ? luw.city.name : ''"
            v-validate="{required: parseInt(luw.type) === 1}" v-bind:error="errors.first('city_id')" v-bind:data-vv-as="' '"
		></z-input-autocomplete>

		<z-input-autocomplete
            v-show="parseInt(luw.type) === 2"
			v-model="luw.zone_id" name="zone_id" id="zone_id" display-property="name" property="id" return="id" label="Направление"
            v-bind:callback="getZones" v-bind:default="luw.zone && luw.zone.name ? luw.zone.name : ''"
            v-validate="{required: parseInt(luw.type) === 2}" v-bind:error="errors.first('zone_id')" v-bind:data-vv-as="' '"
		></z-input-autocomplete>

		<z-input
			v-model="luw.min_time" name="min_time" id="min_time" label="Минимальное вермя (часы)" type="number"
			v-validate="'required|min_value:0'" v-bind:error="errors.first('min_time')" v-bind:required="true"
			data-vv-name="min_time" v-bind:data-vv-as="' '"
		></z-input>

        <z-input
			v-model="luw.price" name="price" id="price" label="Цена за 1 час, 1 сотрудника (руб.)" type="number"
			v-validate="'required|min_value:0'" v-bind:error="errors.first('price')" v-bind:required="true"
			data-vv-name="price" v-bind:data-vv-as="' '"
		></z-input>
    </entity-page>
</template>
<script>
	import ZInput from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
	import EntityPage  from '@/components/EntityPage.vue';
    import ZIconButton from '@/components/ZIconButton';
	import ZInputAutocomplete from '@/components/ZInputAutocomplete';
	export default {
		components: { ZInputAutocomplete, ZInput, ZSelect, ZIconButton, EntityPage },
		data() {
			return {
				luw: {},
				luwDefault: {
                    id: null,
                    min_time: 1,
                    price: 0,
                    type: null,
                    city_id: null,
                    zone_id: null,
				},
                types: {
                    1: {
                        name: 'Город',
                        value: 1,
                    },
                    2: {
                        name: 'Направление',
                        value: 2,
                    }                   
                }                
			}
		},
		computed: {
			/**
             * Флаг загрузки текущего компонента
             */
			progress() {
				return this.progressObj['load-luw-card'];
			},
			/**
             * Объект с флагами загрузки
             */
			progressObj() {
				return this.$store.state.progressObj;
			}
		},
		watch: {
			'$route.params.id'() {
				this.init();
			},
            'luw.type'(val) {
                if (parseInt(val) === 1) {
                    this.luw.zone_id = null;
                    this.luw.zone = {};
                } else if (parseInt(val) === 2) {
                    this.luw.city_id = null;
                    this.luw.city = {};
                }
            }
		},
		methods: {
			/**
             * Инициализация компонента
             */
			init() {
				this.$store.commit('openRightPanel');
				if (this.$route.params.id !== 'new') this.getLuw();
				else this.luw = Object.assign({}, this.luwDefault);
			},
			/**
			 * Получение ценгы
			 */
			getLuw() {
				this.$store.commit('showProgressBar', 'load-luw-card');
				return this.$store.dispatch('cost/getLuw', this.$route.params.id).then(r => {
					this.luw = Object.assign({}, r);
					return this.luw;
				}).finally(() => this.$store.commit('hideProgressBar', 'load-luw-card'));
			},
			/**
			 * Сохранение
			 */
			save() {
				this.$validator.validateAll().then(valid => {
					if (!valid) return;
					if (this.$route.params.id != 'new') this.putLuw();
                    else this.postLuw();
				});
			},
			/**
			 * Добавление цены
			 */
			postLuw() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    this.$store.commit('showProgressBar', 'load-luw-card');
                    this.$store.dispatch('cost/postLuw', this.luw).then(r => {
                        this.$root.$emit('reload-table', 'luws');
                        this.$router.replace({name: 'LuwPrice', params: {id: r.id}});
                    }).finally(() => this.$store.commit('hideProgressBar', 'load-luw-card'));
                });
			},
			/**
			 * Изменение цены
			 */
			putLuw() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    this.$store.commit('showProgressBar', 'load-luw-card');
                    this.$store.dispatch('cost/putLuw', this.luw).then(r => {
                        if (!r) return;
                        this.init();
                        this.$root.$emit('reload-table', 'luws');
                    }).finally(() => this.$store.commit('hideProgressBar', 'load-luw-card'));
                });
			},
			/**
			 * Получение направлений
			 */
			getZones(string) {
				if (string && string.length > 3) return this.$store.dispatch('cost/getZones', {
					page: 1, count: 20,
					filter: {model: [['name', '%', string]]}
				});
			},
            /**
             * Подставление города
             */
             getCities(searchString) {
                if (searchString && searchString.length >= 3) return this.$store.dispatch('cost/getCities', {
                    page: 1, count: 20,
                    filter: {model: [['name', '%', searchString], 'or', ['value', '%', searchString]]} 
                });
            },            
			/**
             *Возвращает пользователя на предыдущую страницу
            * Обрабочик события click, на кнопке "Закрыть" 
            */
			back() {
                this.$router.push({name: 'LuwPrices', query: this.$route.query});
            }
		},
		created() {
			this.init();
		}		
	}
</script>


// WEBPACK FOOTER //
// Luw.vue?38aff4b9